// src/components/Hero.js
import React from 'react';


const Hero = () => {
    return (
      <div className="relative w-full overflow-hidden bg-black">
        <div className="w-full flex justify-center main-image">
          <img
            src="https://i0.wp.com/illinoisanswers.org/wp-content/uploads/2024/05/B0011735-scaled.jpg?resize=2000%2C1499&ssl=1"
            alt="The Chairs: Restrained in Illinois"
            className=" object-contain h-100 w-4/6"
          />
        </div>
        <div className="absolute inset-0 bg-black bg-opacity-50 flex flex-col justify-center items-center text-center page-header">

          <h1 className="text-white  font-ivypresto mb-2">Strapped Down</h1>
          <h2 className="text-white  mb-7">Restraint Chairs in Illinois Jails</h2>
          <h5 className="text-white  max-w-xl">
          An Illinois Answers Project investigation found county jails in the state restrain people in chairs on average more than 1,000 times a year, often in ways that violate jail policies and last longer than recommended by manufacturers.
          </h5>
        </div>
      </div>
    );
  };

export default Hero;